import { PaymentHistorySectionCombinedProps } from './types';

const usePresenter = (props: PaymentHistorySectionCombinedProps): PaymentHistorySectionCombinedProps => {
  return props;
};

export default usePresenter;
